export default __webpack_public_path__ + "static/media/elle1.5e75b317.webp";